import React,{Component}from 'react';
import PropTypes from 'prop-types';
import {PropTypes as MobxPropTypes} from 'mobx-react';
import ReactDOM from 'react-dom';
import './index.css';
import Index from './index/index';
import registerServiceWorker from './registerServiceWorker';
import ProjectIntroduce from './projectIntroduce/index';
import SkillIntroduce from './skills/index'
import NavBar from './navigator'
import newState from './state'
import {
    HashRouter as Router,
    Route,
    Switch
  } from 'react-router-dom';
  class App extends Component{
    getChildContext(){
      return {store:newState};
    }    
    render(){
      return (
        <Router >
        <div style={{height:'100%'}} className="App">
        <NavBar />
        <Switch>
          <Route exact path="/" component={Index}/>
          <Route path="/projectIntroduce" component={ProjectIntroduce}/>
          <Route path='/skillintro' component={SkillIntroduce} />
        </Switch>
        </div>
      </Router>)
    }
  }
 App.childContextTypes = {
  store: MobxPropTypes.observableObject.isRequired
}
  ReactDOM.render(
    <App />,
    document.getElementById('root'));
  // registerServiceWorker(); 
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js